import React from 'react';
import Layout from 'Layout/Layout';
import Loader from 'Layout/Loader';

class ContentPlaceholder extends React.Component {
    render() {
        return (
            <Layout page="diet-settings">
                <div className="full-height">
                    <Loader />
                </div>
            </Layout>
        );
    }
}

export default ContentPlaceholder;
